import 'ng-toast';
import 'angular-selectize2/dist/angular-selectize';
import cacheAngularTemplate from 'cacheAngularTemplate';

import 'Careers/angularModule';
import 'DialogModal/angularModule';
import 'ClientStorage/angularModule';
import 'ErrorLogging/angularModule';
import 'EventLogger/angularModule';
import 'FrontRoyalTimer/angularModule';
import 'FrontRoyalUiBootstrap/angularModule';
import 'Institutions/angularModule';
import 'guid/angularModule';
import 'IsMobile/angularModule';
import 'LearnerContentCache/angularModule';
import 'OfflineMode/angularModule';
import 'OnImageLoad/angularModule';
import 'SafeApply/angularModule';
import 'ScrollHelper/angularModule';
import 'SearchEngineOptimization/angularModule';
import 'Sequence/angularModule';
import 'Translation/angularModule';
import 'Users/angularModule';
import { navigationHelper } from 'NavigationHelpers';

import sessionsNavigationFullWidth from 'Navigation/angularModule/views/sessions_navigation_full_width.html';
import { registerReactRouterBridge } from './react_router_bridge';

const frontRoyalNavigationModule = angular.module('FrontRoyal.Navigation', [
    'FrontRoyal.Careers',
    'LearnerContentCache',
    'scrollHelper',
    'AClassAbove',
    'ClientStorage',
    'EventLogger',
    'FrontRoyal.Institutions',
    'Translation',
    'FrontRoyal.UiBootstrap',
    'FrontRoyal.Users',
    'guid',
    'FrontRoyalTimer',
    'ngToast',
    'selectize',
    'onImageLoad',
    'SiteMetadata',
    'DialogModal',
    'FrontRoyal.ErrorLogService',
    'isMobile',
    'safeApply',
    'Sequence',
    'OfflineMode',
]);

registerReactRouterBridge(frontRoyalNavigationModule);

angular.module('FrontRoyal.Navigation').run([
    '$injector',
    $injector => {
        const $rootScope = $injector.get('$rootScope');
        const $window = $injector.get('$window');
        const EventLogger = $injector.get('EventLogger');
        const reactRouterBridge = $injector.get('reactRouterBridge');
        const navigationHelpers = navigationHelper();
        const { loadRoute } = navigationHelpers;
        Object.defineProperty($rootScope, 'homePath', {
            get() {
                const user = $rootScope.currentUser;

                if (!user) return $window.CORDOVA ? '/onboarding/hybrid' : '/';

                return '/dashboard';
            },
            configurable: true,
        });

        Object.defineProperty($rootScope, 'postLogoutSignInPath', {
            get: () => {
                // At one point this was an if / else if because we were building
                // an app for the external institution Uber, which we did NOT want to
                // touch the onboarding experience. But then we built an app for
                // Miya Miya, which we DID want to use the onboarding experience. So
                // if we ever need to do something similar to Uber again then we'll need
                // to reconcile this forcedUrlPrefix and onboarding logic appropriately.
                // if ($window.CORDOVA.forcedUrlPrefix) {
                //     loadRoute(`/${$window.CORDOVA.forcedUrlPrefix}/sign-in`);
                if ($window.CORDOVA) {
                    return '/onboarding/hybrid/login';
                }
                return '/sign-in';
            },
        });

        $rootScope.goHome = (caller = 'unknown', extra = {}) => {
            EventLogger.log('debug_onboarding_issue:navigation_go_home', {
                params: { homePath: $rootScope.homePath, caller, ...extra },
            });

            loadRoute($rootScope.homePath);
        };

        // see comment in route_resolvers.js
        $rootScope.redirectHomeWhileRouting = (caller = 'unknown', extra = {}) => {
            // If we're sending the user to the place they were going anyway,
            // we have to resolve the original promise.  Redirect won't work
            if (!reactRouterBridge.path() || reactRouterBridge.path() === $rootScope.homePath) {
                return;
            }

            EventLogger.log('debug_onboarding_issue:navigation_redirect_home_while_routing', {
                params: {
                    caller,
                    originalPath: reactRouterBridge.path(),
                    homePath: $rootScope.homePath,
                    ...extra,
                },
            });

            // If we're sending them to a new place, then we reject with a redirect
            // oxlint-disable-next-line no-throw-literal
            throw { redirect: $rootScope.homePath };
        };
    },
]);

cacheAngularTemplate(
    frontRoyalNavigationModule,
    'Navigation/sessions_navigation_full_width.html',
    sessionsNavigationFullWidth,
);

export default frontRoyalNavigationModule;
